import React from "react";
import { formatCurrency } from "../../../../utils/SamuiUtils";

export default React.memo(function DataTable({
  fields,
  data,
  onSort,
  sortField,
  sortOrder,
  onRowClick,
  sums,
}) {
  return (
    <div className="card p-2">
      <div
        className="table-responsive"
        style={{ height: "70vh", overflowY: "auto" }}
      >
        <table className="table table-striped table-hover">
          <thead className="thead-dark">
            <tr>
              <th style={{ width: "2%" }} className="text-center">
                #
              </th>
              {fields.map((f) => (
                <th
                  key={f.key}
                  style={{
                    width: f.w,
                    cursor: f.sortable ? "pointer" : "default",
                  }}
                  className={`text-${f.alignHeader}`}
                  onClick={() => f.sortable && onSort(f.key)}
                >
                  {f.label}
                  {f.key === sortField && (sortOrder === "asc" ? " ▲" : " ▼")}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map((item, i) => (
                <tr
                  key={i}
                  style={{ cursor: "pointer" }}
                  onClick={() => onRowClick(i)}
                >
                  <td className="text-center">{i + 1}</td>
                  {fields.map((f) => (
                    <td key={f.key} className={`text-${f.align}`}>
                      {f.key === "DocStatusPaid_Name"
                        ? (() => {
                            const colourKey = f.key.replace("_Name", "_Colour");
                            return (
                              <span
                                className="badge d-block w-100 text-center"
                                style={{
                                  backgroundColor: item[colourKey],
                                  color: "#fff",
                                }}
                              >
                                {item[f.key]}
                              </span>
                            );
                          })()
                        : f.key === "Doc_Date"
                        ? formatThaiDateUi(item[f.key])
                        : f.key === "DocStatusPaid_Type_Name"
                        ? (() => {
                            const colourKey = f.key.replace("_Type_Name", "Type_Colour");
                            return (
                              <span
                                className="badge d-block w-100 text-center"
                                style={{
                                  backgroundColor: item[colourKey],
                                  color: "#fff",
                                }}
                              >
                                {item[f.key]}
                              </span>
                            );
                          })()
                        : f.numeric
                        ? formatCurrency(item[f.key])
                        : item[f.key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={fields.length + 1}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={3} className="text-end">
                รวมทั้งหมด {data.length} รายการ
              </th>
              <th colSpan={fields.length - 1} className="text-end">
                {formatCurrency(sums.sumNetTotal || 0)}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});
